/**
 * 判断图片是否超过 15M，超过则压缩到 10 - 15M 之间，若尺寸超过 1600 像素则缩小尺寸
 * @param {File} file - 要处理的图片文件
 * @returns {Promise<File>} - 处理后的图片文件
 */
async function compressImageIfNeeded(file) {
    const MAX_SIZE = 15 * 1024 * 1024; // 15M
    const MIN_SIZE = 10 * 1024 * 1024; // 10M
    const MAX_DIMENSION = 3000; // 最大像素尺寸

    if (file.size <= MAX_SIZE) {
        return file;
    }

    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
            let width = img.width;
            let height = img.height;
            // 如果图片尺寸超过 1600 像素，按比例缩小
            if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
                const ratio = Math.min(MAX_DIMENSION / width, MAX_DIMENSION / height);
                width = Math.floor(width * ratio);
                height = Math.floor(height * ratio);
            }

            let quality = 0.9;
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            let compressedBlob;
            // 循环压缩直到图片大小在 10 - 15M 之间
            const compressLoop = () => {
                canvas.toBlob(
                    (blob) => {
                        if (!blob) {
                            reject(new Error('图片压缩失败'));
                            return;
                        }

                        compressedBlob = blob;
                        if (blob.size >= MIN_SIZE && blob.size <= MAX_SIZE) {
                            const compressedFile = new File([compressedBlob], file.name, {
                                type: file.type,
                                lastModified: Date.now()
                            });
                            resolve(compressedFile);
                        } else if (blob.size > MAX_SIZE && quality > 0.1) {
                            quality -= 0.1;
                            compressLoop();
                        } else {
                            // 如果无法压缩到指定范围，返回当前压缩结果
                            const compressedFile = new File([compressedBlob], file.name, {
                                type: file.type,
                                lastModified: Date.now()
                            });
                            resolve(compressedFile);
                        }
                    },
                    file.type,
                    quality
                );
            };

            compressLoop();
        };

        img.onerror = () => {
            reject(new Error('图片加载失败'));
        };
    });
}

export { compressImageIfNeeded };